export default __webpack_public_path__ + "static/media/battery-recharge.ea86a6da.svg";